<template>
  <v-footer
    v-if="usuarioLogado && user.tipo != 'ENFERMAGEM'"
    app
    inset
    color="white"
    class="ai-footer"
  >
    <span class="ai-footer__text">© {{ new Date().getFullYear() }} AiNurse · Intelite Tecnologia</span>
    <v-spacer></v-spacer>
    <v-btn
      icon
      small
      href="https://www.instagram.com/intelite_tecnologia/"
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
    >
      <v-icon small>mdi-instagram</v-icon>
    </v-btn>
  </v-footer>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
    }),

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
    },
  }
</script>

<style scoped>
.ai-footer {
  border-top: 1px solid #e8ebf2;
}
.ai-footer__text {
  font-size: 0.78rem;
  color: #8a93a6;
}
</style>
